import { Controller } from "@hotwired/stimulus"

// Expand/collapse a round's session list.
//
// The open state is persisted because this row lives on a page whose controls
// (subscribe, save, the country selector) all redirect. Without persistence
// the panel snaps shut on every one of them, and it looks like an event bug
// rather than a re-render. See .claude/rules/persist-ui-state.md
export default class extends Controller {
  static targets = ["panel", "chevron"]
  static values = { id: String }

  connect() {
    if (this.idValue && localStorage.getItem(this.storageKey) === "open")
      this.open()
  }

  toggle() {
    this.panelTarget.classList.contains("hidden") ? this.open() : this.close()
  }

  open() {
    if (!this.hasPanelTarget) return
    this.panelTarget.classList.remove("hidden")
    this.chevronTarget.classList.add("rotate-180")
    this.element.querySelector("button")?.setAttribute("aria-expanded", "true")
    if (this.idValue) localStorage.setItem(this.storageKey, "open")
  }

  close() {
    this.panelTarget.classList.add("hidden")
    this.chevronTarget.classList.remove("rotate-180")
    this.element.querySelector("button")?.setAttribute("aria-expanded", "false")
    if (this.idValue) localStorage.removeItem(this.storageKey)
  }

  get storageKey() {
    return `racing-round:${this.idValue}`
  }
}
